@if(isParticipantFlow) {
    <app-participant-sick-time></app-participant-sick-time>
}

@else {
    <app-provider-sick-time [isReadOnly]="isReadOnly"></app-provider-sick-time>
}